module.exports = __webpack_public_path__ + "img/imgc.9aa573cc.png";